// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/pulse'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import JsonExcel from 'vue-json-excel'
import VueMask from 'v-mask'
import ApexCharts from 'apexcharts'
import 'primeicons/primeicons.css'
import './styles/pulse.css'

import "emoji-picker-element";
Vue.config.ignoredElements = ['emoji-picker'];

import {
  initAuthTokenFromUrl,
  initPortalAuthBridge,
  syncUserSession,
  validarTokenOuRedirecionar,
  logoutToPortal,
  solicitarNovoToken,
} from './auth/token'

import pt from 'vuetify/lib/locale/pt';

Vue.config.productionTip = false
Vue.use(VueMask);

Vue.component('downloadExcel', JsonExcel)

// Role-based route guards — executados após a sessão ser sincronizada no bootstrap.
router.beforeEach((to, from, next) => {
  if (to.path != '/login' && to.path != '/cadastro') {
    const user = JSON.parse(sessionStorage.getItem('user'))

    if (user == null || !user.roles) {
      return next('/login');
    }

    if (to.path == '/contrato') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_CONTRATO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/cobranca') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_COBRANCA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/negativados') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_NEGATIVADO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/importacao') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_IMPORTACAO_RADAR')) {
        router.push('restrito');
      }
    }

    if (to.path == '/indicadores') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_STRATUS')) {
        router.push('restrito');
      }
    }

    if (to.path == '/modulo-comercial') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_COMERCIAL')) {
        router.push('restrito');
      }
    }

    if (to.path == '/modulo-assinatura-digital') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_ASSINATURA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/modulo-colaborador') {
      if (!user || !user.roles || (Array.isArray(user.roles) && user.roles.length === 0)) {
        router.push('restrito');
      }
    }

    if (to.path == '/central-consultas-analise') {
      if (!user.roles.includes('ROLE_ADMIN')) {
        router.push('restrito');
      }
    }

    if (to.path == '/central-consultas-saldo') {
      if (!user.roles.includes('ROLE_ADMIN')) {
        router.push('restrito');
      }
    }

    if (to.path == '/consulta-ltv') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_LTV')) {
        router.push('restrito');
      }
    }

    if (to.path == '/tem-saude') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_ADMINISTRADOR_TEMSAUDE_CARTAO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/tem-saude-lote') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_ADMINISTRADOR_TEMSAUDE_LISTAGEM')) {
        router.push('restrito');
      }
    }

    if (to.path == '/campanha-upload') {
      if (!user.roles.includes('ROLE_ADMIN')) {
        router.push('restrito');
      }
    }

    if (to.path == '/invita') {
      if (!user.roles.includes('ROLE_ADMIN')) {
        router.push('restrito');
      }
    }

    if (to.path == '/fluxo') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_FLUXO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/remessa') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_REMESSA_NEGATIVADO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/relatoriosSeguro') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_SEGUROS')) {
        router.push('restrito');
      }
    }

    if (to.path == '/obito') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_OBITO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/usuario') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_USER')) {
        router.push('restrito');
      }
    }

    if (to.path == '/historico') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_LOG')) {
        router.push('restrito');
      }
    }

    if (to.path == '/faturamento') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_FATURAMENTO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/retencao') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_RETENCAO') && !user.roles.includes('ROLE_RETENCAO_VENDEDOR')) {
        router.push('restrito');
      }
    }

    if (to.path == '/sepultamento') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_SEPULTAMENTO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/cancelamento') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_CANCELAMENTO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/venda') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_VENDA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/acordos') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_RENEGOCIACAO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/inadimplencia') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_INADIMPLENCIA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/campanha') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_CAMPANHA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/acompanhamentovenda') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_ACOMPANHAMENTO_VENDA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/campanha2') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_CAMPANHA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/auditoria') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_AUDITORIA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/') {
      router.push('inicio');
    }

    if (to.path == '/receita') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_RECEITA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/consultaMassa' || to.path == '/consultaDinamica') {
      if (!user.roles.includes('ROLE_ADMIN')) {
        router.push('restrito');
      }
    }

    if (to.path == '/chat-wazzup') {
      if (!user.roles.includes('ROLE_ADMIN')) {
        router.push('restrito');
      }
    }

    if (to.path == '/portal-socios') {
      if (!user.roles.includes('ROLE_ADMIN')) {
        router.push('restrito');
      }
    }

    if (to.path == '/notificacao') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_NOTIFICACAO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/financeiro') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_RESUMO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/contas') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_CONTAS')) {
        router.push('restrito');
      }
    }

    if (to.path == '/inadimplenciaPerformance') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_INADIMPLENCIA_PERFORMANCE')) {
        router.push('restrito');
      }
    }

    if (to.path == '/comissao') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_COMISSAO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/funeraria') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_FUNERARIA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/loja') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_LOJA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/comissaoVenda') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_COMISSAO_VENDA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/simulacaoVenda') {
      if (!user.roles.includes('ROLE_ADMIN')) {
        router.push('restrito');
      }
    }

    if (to.path == '/comissaoEntrega') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_COMISSAO_ENTREGAS')) {
        router.push('restrito');
      }
    }

    if (to.path == '/comissaoControle') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_COMISSAO_CONTROLE')) {
        router.push('restrito');
      }
    }

    if (to.path == '/comissaoConformidade') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_COMISSAO_CONTROLE')) {
        router.push('restrito');
      }
    }

    if (to.path == '/vendasRadar') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_VENDAS_RADAR')) {
        router.push('restrito');
      }
    }

    if (to.path == '/documentos') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_MANUTENCAO_DOC')) {
        router.push('restrito');
      }
    }

    if (to.path == '/comissaoAlelo') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_COMISSAO_ALELO')) {
        router.push('restrito');
      }
    }

    if (to.path == '/bitrixLead') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_BITRIX')) {
        router.push('restrito');
      }
    }

    if (to.path == '/comissaoFuneraria') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_COMISSAO_FUNERARIA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/acordosPerformance') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_ACORDO_PERFORMANCE')) {
        router.push('restrito');
      }
    }

    if (to.path == '/vendasEmpresas') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_VENDAS_EMPRESA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/sinistralidade') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_SINISTRALIDADE')) {
        router.push('restrito');
      }
    }

    if (to.path == '/falecidos') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_FALECIDOS')) {
        router.push('restrito');
      }
    }

    if (to.path == '/consulta-glpi' || to.path == '/acompanhamento-glpi') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_GLPI')) {
        router.push('restrito');
      }
    }

    if (to.path == '/chat') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_CHAT')) {
        router.push('restrito');
      }
    }

    if (to.path == '/etiquetas') {
      if (
        !user.roles.includes('ROLE_ADMIN') &&
        !user.roles.includes('ROLE_ETIQUETA_CONSULTA') &&
        !user.roles.includes('ROLE_ETIQUETA_CADASTRO')
      ) {
        router.push('restrito');
      }
    }

    if (to.path == '/consulta-chat') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_CHAT_CONSULTA')) {
        router.push('restrito');
      }
    }

    if (to.path == '/painel-chat') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_CHAT_PAINEL')) {
        router.push('restrito');
      }
    }

    if (to.path == '/parametros') {
      if (
        !user.roles.includes('ROLE_ADMIN') &&
        !user.roles.includes('ROLE_PARAMETROS') &&
        !user.roles.includes('ROLE_PARAMETROS_CONSULTA') &&
        !user.roles.includes('ROLE_PARAMETROS_CADASTRO') &&
        !user.roles.includes('ROLE_TEMPLATES')
      ) {
        router.push('restrito');
      }
    }

    if (to.path == '/teste') {
      if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_TESTE')) {
        router.push('restrito');
      }
    }
  }

  next()
})

async function bootstrap () {
  console.log('[app-operacao] bootstrap start', {
    href: window.location.href,
    apiUrl: process.env.VUE_APP_API_URL,
    portalOrigin: process.env.VUE_APP_PORTAL_ORIGIN,
    inIframe: window.parent !== window,
  })

  initPortalAuthBridge()
  initAuthTokenFromUrl()

  const tokenValido = await validarTokenOuRedirecionar()
  console.log('[app-operacao] validarTokenOuRedirecionar =', tokenValido)
  if (!tokenValido) {
    console.warn('[app-operacao] token inválido/ausente — redirecionando (app não monta)')
    return
  }

  const user = syncUserSession()
  console.log('[app-operacao] user session', user && {
    username: user.username || user.login,
    roles: user.roles,
  })

  const loadingEl = document.getElementById('auth-loading')
  if (loadingEl) loadingEl.remove()

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    components: { ApexCharts },
    lang: {
      locales: { pt },
      current: 'pt',
    },
    render: (h) => h(App),
  }).$mount('#app')
  console.log('[app-operacao] Vue montado em #app')
}

bootstrap().catch((err) => {
  console.error('[app-operacao] bootstrap falhou', err)
})
